import { WrapperSize } from '@preventx/oxygen';

// Types
import { PrismicWrapperSize } from '@/types/box';

export const wrapperSize = (size: PrismicWrapperSize): WrapperSize => {
  if (size === 'xxl') {
    return '2xl';
  }

  if (size === 'xxs') {
    return '2xs';
  }

  return size;
};
